import type { ReactNode } from 'react';
import type { User } from '../types';

export type ViewName = 'dashboard' | 'review' | 'browse' | 'summaries' | 'games' | 'analytics' | 'settings';

const NAV: Array<{ id: ViewName; icon: string; label: string }> = [
  { id: 'dashboard', icon: '🏠', label: 'Dashboard' },
  { id: 'review', icon: '🎯', label: 'Lernen' },
  { id: 'browse', icon: '🗂️', label: 'Karteikarten' },
  { id: 'summaries', icon: '📖', label: 'Zusammenfassungen' },
  { id: 'games', icon: '🎮', label: 'Übungen' },
  { id: 'analytics', icon: '📈', label: 'Analyse' },
  { id: 'settings', icon: '⚙️', label: 'Einstellungen' },
];

interface Props {
  activeView: ViewName;
  onNavigate: (view: ViewName) => void;
  streak: number;
  user: User;
  syncStatus: string;
  onLogout: () => void;
  onToggleTheme: () => void;
  children: ReactNode;
}

export function Layout({ activeView, onNavigate, streak, user, syncStatus, onLogout, onToggleTheme, children }: Props) {
  return (
    <div id="app">
      <aside className="sidebar" id="appSidebar">
        <div className="brand">
          <div className="brand-logo">📚</div>
          <div>
            <div className="brand-title">Klausurphase</div>
            <div className="brand-sub">React Smart Flashcards</div>
          </div>
        </div>
        <nav className="nav">
          {NAV.map((item) => (
            <button key={item.id} className={`nav-item ${activeView === item.id ? 'active' : ''}`} onClick={() => onNavigate(item.id)}>
              <span>{item.icon}</span>{item.label}
            </button>
          ))}
        </nav>
        <div className="streak-box">
          <div className="streak-label">Streak</div>
          <div className="streak-value"><span>{streak}</span> 🔥</div>
          <div className="streak-sub">Lerne heute, um den Streak zu halten</div>
        </div>
        <div className="account-chip">
          <div className="account-info">
            <div className="account-email" title={user.email}>{user.email}</div>
            <div className="account-sync muted">{syncStatus}</div>
          </div>
          <button type="button" className="btn-ghost small" title="Abmelden" onClick={onLogout}>↪</button>
        </div>
        <div className="theme-toggle"><button title="Theme wechseln" onClick={onToggleTheme}>🌙</button></div>
      </aside>
      <main className="main">{children}</main>
    </div>
  );
}
